import React from "react";
import "./App.css";
import Main from './components/MainComponent'


class App extends React.Component {
  render() {
    return (
      <Main />
    );
  }
}

export default App;
